var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isAvailable || _vm.$store.page.isInEditMode)?_c('ContentModule',{attrs:{"instance":_vm.finalInstance,"lang":_vm.lang,"id":_vm.id,"country":_vm.country}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }